import { put } from 'redux-saga/effects';

import * as endpoint from 'misc/endpoint';
import * as types from 'misc/types';

export function* checkStatus(action) {
    try {
        const response = yield endpoint.get('maintenance');

        let server_status = {
            running: response.status === 200 ? true : false,
            message: response.data.message
        }

        yield put({ type: types.SAGA_STATUS_CHECK.SUCCESS, payload: server_status });
    } catch (error) {
        let server_status = {
            running: false,
            message: error.response.data.message
        }
        yield put({ type: types.SAGA_STATUS_CHECK.SUCCESS, payload: server_status });
    }
}


// WEBPACK FOOTER //
// ./src/sagas/status_check.js